<template>
    <div>
        <Breadcrumbs :type="type" :header="title" :url="url"></Breadcrumbs>
        <div class="max-w-lg bg-white rounded-md shadow overflow-hidden">
            <form @submit.prevent="store">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                    <text-input v-model="form.title" :error="form.errors.title" class="pb-8 pr-6 w-full lg:w-1/1"
                        label="Title" required="true" placeholder="i.e New Features" @keyup="slugBuild" />
                    <text-input v-model="form.slug" :error="form.errors.slug" class="pb-8 pr-6 w-full lg:w-1/1"
                        label="Slug" required="true" placeholder="i.e new-features" />
                    <select-input v-model="form.parent_id" :error="form.errors.parent_id" class="pb-8 pr-6 w-full lg:w-1/1"
                        label="Parent Category">
                        <option :value="null">Select Parent Category</option>
                        <option v-for="parentCategory in parentCat" :key="parentCategory.id" :value='parentCategory.id'>
                            {{ parentCategory.title }}
                        </option>
                    </select-input>
                    <status-toogle-button v-model="form.status" :error="form.errors.status" class="pb-8 pr-6 w-full lg:w-1/1"
                        label="Status"></status-toogle-button>
                </div>
                <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <loading-button :loading="form.processing" class="btn-indigo" type="submit"><i
                            class="fa fa-check-circle"></i> Create Category</loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import Breadcrumbs from '@/Shared/Breadcrumbs'
import Button from '@/Shared/Button'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '@/Shared/SelectInput'
import StatusToogleButton from '@/Shared/StatusToogleButton'
import TextInput from '@/Shared/TextInput'
import { Head, Link, useForm } from '@inertiajs/inertia-vue3'
import { ref, inject, toRefs } from 'vue'
import { Quill, VueEditor } from "vue3-editor"

export default {
    components: {
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
        Breadcrumbs,
        StatusToogleButton,
        Button,
        Quill,
        VueEditor
    },
    props: {
        parentCat: Array,
    },
    layout: Layout,
    remember: 'form',
    setup() {
        const type = ref('create')
        const title = ref('Release Note Category')
        const url = ref('/backend/release-note-categories')
        const createUrl = ref('')
        const categories = ref([])
        const swal = inject('$swal')
        const form = useForm({
            title: null,
            slug: null,
            parent_id: null,
            status: true,
        })

        const slugBuild = () => {
            form.slug = form.title.replace(/\s/g, '-').toLowerCase()
        }

        const store = () => {
            swal({
                title: 'Are you sure?',
                text: "You want to proceed with this action",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
            }).then((result) => {
                if (result.isConfirmed) {
                    form.post(`${url.value}`, { forceFormData: true, })
                    swal.fire(
                        'Added!',
                        'Your information has been Added.',
                        'success'
                    )
                }
            });

        }

        return {
            form,
            type,
            title,
            url,
            createUrl,
            store,
            categories,
            slugBuild
        }
    },
}
</script>
